import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { BASE_URL } from "../../constants";

const NewFooter = () => {
  return (
    <footer className="footer">
      <div>
        {/* Logo and Headings Row */}
        <Row className="g-4">
          {/* Logo Section */}
          <Col xs={12} md={4} lg={4}>
            <div className="logo-section" style={{cursor:"pointer"}}>
             <Link to="/"> <img
                src={`${BASE_URL}logos/footer_logo.png`}
                alt="Dsider"
                className="logo mb-4"
              /></Link>
              <div className="text-footer">
                Dsider democratizes analysis by integrating knowledge,
                economics, and efficient workflows, enabling users at all levels
                to make smarter, more collaborative decisions. Our AI-driven
                software divowers real-time decision-making in the Energy
                sector, ensuring precision, efficiency, and lasting value from
                strategy to operations.
              </div>
            </div>
          </Col>

          {/* Solutions Section */}
          <Col xs={6} md={2}>
            <div className="solutions-section">
              <h3 className="section-heading h6">
                <Link
                  to="/industries"
                  className="text-decoration-none text-dark"
                >
                  Industries
                </Link>
              </h3>
              {/* Add list items here if needed */}
            </div>
          </Col>

          {/* Technology Section */}
          <Col xs={6} md={2}>
            <div className="technology-section">
              <h3 className="section-heading h6">
                <NavLink
                  to="/technology"
                  className={({ isActive }) =>
                    isActive
                      ? "active-link text-decoration-none"
                      : "text-decoration-none text-dark"
                  }
                >
                  Technology
                </NavLink>
              </h3>
              {/* Add list items here if needed */}
            </div>
          </Col>

          {/* Products Section */}
          <Col xs={6} md={2}>
            <div className="products-section">
              <h3 className="section-heading h6">
                <NavLink
                  to="/products"
                  className={({ isActive }) =>
                    isActive
                      ? "active-link text-decoration-none"
                      : "text-decoration-none text-dark"
                  }
                >
                  Products
                </NavLink>
              </h3>
              {/* Add list items here if needed */}
            </div>
          </Col>

          {/* Contact Us Section */}
          <Col xs={6} md={2}>
            <div className="case-studies-section">
              <h3 className="section-heading h6">
                <NavLink
                  to="/contact"
                  className={({ isActive }) =>
                    isActive
                      ? "active-link text-decoration-none"
                      : "text-decoration-none text-dark"
                  }
                >
                  Contact Us
                </NavLink>
              </h3>
              {/* Add list items here if needed */}
            </div>
          </Col>
        </Row>

        {/* LinkedIn and Email Section */}
        <Row className="mt-4">
          <Col xs={12} className="d-flex align-items-center gap-3">
            <a
              href="https://www.linkedin.com/company/dsider/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={`${BASE_URL}common-images/linkedin_image.png
`}
                alt="LinkedIn"
                className="linkedin-img rounded-circle"
                style={{ width: "48px", height: "48px" }}
              />
            </a>
            <a
              href="mailto:info@dsider.app"
              className="email-link text-dark text-decoration-none"
            >
              info@dsider.app
            </a>
          </Col>
        </Row>
      </div>
    </footer>
  );
};

export default NewFooter;
